import { GroupableTags } from '@components/TagDialog/TagDialog.types';
import {
  PossibleTagsVal,
  toGroupTagsArgs,
} from '@components/TagDialog/TagDialog.utils';
import { StyledDiv } from './AssetMobileTagList.styles';

interface ITagList {
  tags: PossibleTagsVal;
  renderTag: (tag: GroupableTags) => React.ReactNode;
  rightSection: React.ReactNode;
}
export function AssetMobileTagList(props: ITagList) {
  const { tags, renderTag, rightSection } = props;
  const tagsMapped = toGroupTagsArgs(tags)[0];
  const tagsToRender = tagsMapped.map(renderTag);

  return (
    <StyledDiv>
      <div className="AssetMobileTagList_list">{tagsToRender}</div>
      {rightSection}
    </StyledDiv>
  );
}
